import { UserOutlined } from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const consignatario: MenuConfigItem[] = [
  {
    label: "CONSIGNATÁRIOS",
    key: "/consignatarios",
    path: "/consignatarios",
    icon: <UserOutlined />,
    children: [
      {
        label: "PRESTAÇÃO DE CONTAS",
        key: "/prestacaoConta",
        path: "/prestacaoConta",
      },
      {
        label: "CARTEIRA",
        key: "/lancamentoConsignatario",
        path: "/lancamentoConsignatario",
      },
    ],
  },
];
